import {MinimalUserModel, UserModel} from '@core/api/data-access';
import {Cached} from '@utils';

export class CommonUserIconsData {
	public static readonly ICONS = {
		phone: 'fad fa-comment-sms text-primary-500 fa-lg',
		sms: 'fad fa-comment-sms text-primary-500 fa-lg',
		email: 'fad fa-at text-info-500',
		whatsapp: 'fab fa-whatsapp text-success-500 fa-lg',
		permanentUser: 'fad fa-user text-primary-500',
		tempUser: 'fad fa-user-clock text-warning-500',
		disabledUser: 'fad fa-user-slash text-danger-500',
		remove: 'fas fa-times',
		search: 'fad fa-search',
		spinner: 'fad fa-spinner-third fa-spin',
		noResults: 'fad fa-user-slash',
		loadMore: 'fad fa-ellipsis-h',
		addUser: 'fad fa-plus-circle', // Icon for add button
	} as const;

	@Cached()
	public static getUserIcon(user: UserModel | MinimalUserModel, showCommunicationSrcIconForTempUser = false): string {
		let isTempUser = null;
		if (MinimalUserModel.isMinimalUserModel(user) || UserModel.isUserModel(user)) {
			isTempUser = user.isTemporary;
		}
		if (isTempUser !== null) {
			if (isTempUser) {
				if (showCommunicationSrcIconForTempUser) {
					const normalizeDefaultCommunicationSrc = user.defaultCommunicationSrc.replace('notify', '').toLowerCase();
					return CommonUserIconsData.ICONS[normalizeDefaultCommunicationSrc];
				}
			}
			return CommonUserIconsData.ICONS.permanentUser;
		}
	}
}

export type CommonUserIconsType = keyof typeof CommonUserIconsData.ICONS;
export type CommonUserIconsValue = typeof CommonUserIconsData.ICONS[CommonUserIconsType];